import { useUserPermissions } from 'entities/user';
import useIsAutorizedUser from 'common/hooks/useIsAutorizedUser';

export const useShowUserLogInButton = () => {
  const permissions = useUserPermissions();
  const isAuthorizedUser = useIsAutorizedUser();

  return !(!permissions.loginSiteClient || isAuthorizedUser);
};
